<!--
  @Author 22030124/xieyq
  @Date 2023-08-09 17:56:49
  @Description 人员表格
-->
<template>
  <div ref="con" :class="scope.clsPrefix">
    <!-- 表格 -->
    <el-table
      ref="table"
      :class="`${scope.clsPrefix}_table`"
      height="330"
      row-key="userEmpsn"
      :data="list"
      @current-change="handleCurrentChange"
      @selection-change="handleSelectionChange"
    >
      <!-- 单选或复选 -->
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="45"
        :selectable="selectable"
        v-if="multiple"
      >
      </el-table-column>
      <el-table-column align="center" width="40" v-else>
        <template slot-scope="scope">
          <el-radio
            :value="selectedRowData ? selectedRowData.id : ''"
            :disabled="disabledKeys.indexOf(scope.row.userEmpsn) > -1"
            :label="scope.row.id"
            ><span></span
          ></el-radio>
        </template>
      </el-table-column>
      <!-- 姓名 -->
      <el-table-column
        prop="name"
        :label="$t('common.name')"
        min-width="86"
        show-overflow-tooltip
      ></el-table-column>
      <!-- 工号 -->
      <el-table-column
        prop="userEmpsn"
        :label="$t('common.employeeId')"
        min-width="100"
        show-overflow-tooltip
      ></el-table-column>
      <!-- 邮箱 -->
      <el-table-column
        prop="email"
        :label="$t('common.email')"
        min-width="160"
        show-overflow-tooltip
      ></el-table-column>
      <!-- 部门 -->
      <el-table-column
        prop="idmDeptName"
        :label="$t('search.department')"
        min-width="150"
        show-overflow-tooltip
      ></el-table-column>
      <!-- 小微 -->
      <!-- <el-table-column prop="organizationName" label="小微" min-width="120" show-overflow-tooltip></el-table-column> -->
      <!-- 状态 -->
      <!-- <el-table-column label="状态" min-width="70" show-overflow-tooltip>
        <span slot-scope={row}>{{ employeeStatus(row.idmEmployeeStatus) }}</span>
      </el-table-column> -->
      <!-- 操作列 -->
      <!-- <el-table-column label="操作" fixed='right' align="center" v-if="operation && operation.length" width="90">
        <template slot-scope={row}>
          <el-link
            :underline="false"
             v-for="(item, index) in operation"
            :key="`operate-btn-${index}`"
             type="primary"
            @click.stop="handleOperate(item.key, row)"
          >{{ item.label }}</el-link>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      :class="`${scope.clsPrefix}_page`"
      v-if="pageData && pageData.total > 5"
      background
      :total="pageData.total"
      :current-page.sync="pageData.page"
      :page-size.sync="pageData.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      @size-change="handleSizeChange"
      @current-change="getList"
    />
  </div>
</template>

<script>
import {
  Table,
  Pagination,
  TableColumn,
  Radio,
  Loading
  // Link,
} from 'element-ui'
export default {
  // 组件名称
  name: 'CosmoSelectUserTable',
  components: {
    ElTable: Table,
    ElPagination: Pagination,
    ElTableColumn: TableColumn,
    ElRadio: Radio
    // ElLink: Link,
  },
  // 接收父级参数request请求对象，currentUser当前用户
  inject: ['request', 'currentUser'],
  // 参数选项
  props: {
    // 查询参数
    params: {
      type: Object
    },
    // 信息项数据
    itemData: {
      type: Object,
      required: true
    },
    // 操作列信息
    operation: {
      type: Array
    },
    // 是否多选
    multiple: {
      type: Boolean
    },
    // 置灰的数组
    disabledKeys: {
      type: [Array],
      default: () => []
    },
    // 勾选的行
    selectedRow: {
      type: String
    },
    // 多选勾选的行数据
    selectedRows: {
      type: Array
    }
  },
  // 数据
  data() {
    return {
      // 私有变量
      scope: {
        // class前缀
        clsPrefix: 'cosmo-select-user-table'
      },
      // 是否加载
      loading: false,
      // 表格分页参数
      pageData: { total: 0, page: 1, pageSize: 5 },
      // 列表数据
      list: [],
      // 勾选的行数据
      selectedRowData: null,
      // 多选的行数据
      selectedRowDatas: [],
      // 是否初始化
      initFlag: false
    }
  },
  computed: {
    // 员工状态
    employeeStatus() {
      return (status) => {
        switch (status) {
          case '1':
            return '在岗'
          case '2':
            return '不在岗'
          case '3':
            return '退休'
          case '4':
            return '离职'
          case '9':
            return '死亡'
        }
      }
    },
    // 当前选择的工号
    currentSelectedIds() {
      return this.selectedRowDatas.map((item) => item.userEmpsn)
    },
    // 表格组件对象
    table() {
      return this.$refs.table
    }
  },
  watch: {
    // loading状态
    loading(val) {
      if (val) {
        this.loadingInstance = Loading.service({
          target: this.$refs.con
        })
      } else {
        this.loadingInstance && this.loadingInstance.close()
      }
    },
    // 列表
    list() {
      // 更新选中的行
      this.updateSelect()
    }
  },
  // 创建完成
  created() {},
  // 挂载完成
  mounted() {},

  // 方法
  methods: {
    /**
     * 处理每页显示的条数
     * @param {*} val 每页显示的条数
     * @returns {void}
     */
    handleSizeChange(val) {
      // 跳转到第一页
      this.pageData.page = 1
      // 每页显示的条数赋值
      this.pageData.pageSize = val
      // 刷新列表
      this.getList()
    },

    /**
     * 获取请求参数对象
     * @returns {Object}
     */
    getParams() {
      return {
        ...this.params,
        // 页码
        pageNumber: this.pageData.page,
        // 每页显示的条数
        pageSize: this.pageData.pageSize,
        // 当前用户编码
        userEmpsn: this.currentUser
      }
    },
    getNewParams() {
      return {
        // 页码
        page: this.pageData.page,
        // 每页显示的条数
        size: this.pageData.pageSize,
        // 当前用户编码
        empNo: '',
        empName: this.params.user || ''
      }
    },

    /**
     * 获取列表数据
     * @returns {void}
     */
    getList() {
      // 开始加载
      this.loading = true
      this.itemData.api &&
        this.request[this.itemData.api](this.getNewParams())
          .then(({ data }) => {
            // 数据赋值
            this.list = data.records.map((val, ind) => {
              const value = JSON.parse(JSON.stringify(val))
              value.name = val.displayName
              value.userEmpsn = val.username
              value.idmDeptName = val.department
              return value
            })
            this.pageData.total = data.total
            // 停止加载
            this.loading = false
          })
          .catch(() => {
            // 停止加载
            this.loading = false
          })
    },

    /**
     * 激活
     * @returns {void}
     */
    activated() {
      // 刷新列表
      this.getList()
      this.$nextTick(() => {
        // 更新勾选状态
        this.updateSelect()
      })
    },

    /**
     * 搜索方法
     * @returns {void}
     */
    search() {
      this.pageData.page = 1
      this.getList()
    },

    /**
     * 是否可选
     * @returns {Boolean}
     */
    selectable(row) {
      if (this.disabledKeys.indexOf(row.userEmpsn) > -1) {
        return false
      }
      return true
    },

    /**
     * 进行删除
     * @param {*} row 删除的row
     * @returns {void}
     */
    handleDel(row) {
      // 多选
      if (this.multiple) {
        // 当前选中的信息项
        const sections = this.table.store.states.selection
        let currentRow = row
        sections.some((item) => {
          if (item.userEmpsn === row.userEmpsn) {
            currentRow = item
            return true
          }
          return false
        })
        this.table.store.toggleRowSelection(currentRow, false, false)
        return
      }
      // 取消表格的选中
      this.table.setCurrentRow()
    },

    /**
     * 清空表格
     * @returns {void}
     */
    clearTable() {
      if (!this.table) {
        return
      }
      // 清除选中
      this.clearSelect()
    },

    /**
     * 处理当前勾选的行
     * @param {Aarry} val 勾选的行数据
     * @returns {void}
     */
    handleSelectionChange(val) {
      // 如果是初始化，则直接退出
      if (this.initFlag) {
        return
      }
      // id数组
      const ids = val.map((item) => item.userEmpsn)
      // 新增
      const newRows = val.filter(
        (item) => this.selectedRows.indexOf(item.userEmpsn) === -1
      )
      // 删除
      const delRowIds = this.currentSelectedIds.filter(
        (id) => ids.indexOf(id) === -1
      )
      // 勾选行数据赋值
      this.selectedRowDatas = val || []
      // 通知上层容器选择的选项
      if (newRows && newRows.length) {
        this.$emit('selection-change', newRows)
      }
      // 取消勾选
      if (delRowIds && delRowIds.length) {
        this.$emit('unselection', delRowIds)
      }
    },

    /**
     * 处理行选中
     * @param {Aarry} val 勾选的行数据
     * @returns {void}
     */
    handleCurrentChange(val) {
      // 赋值勾选的行数据
      this.selectedRowData = val
      // 通知上层容器选择的选项
      this.$emit('current-change', this.selectedRowData)
    },

    /**
     * 处理操作按钮事件
     * @param {String} command 指令
     * @param {Object} rowItemData 行信息项数据
     * @returns {void}
     */
    handleOperate(command, rowItemData) {
      // 抛给父组件进行处理
      this.$emit('operate', command, rowItemData)
    },

    /**
     * 清楚选中
     * @returns {void}
     */
    clearSelect() {
      // 清除选中
      this.multiple ? this.table.clearSelection() : this.table.setCurrentRow()
    },

    /**
     * 更新下拉选
     * @returns {void}
     */
    updateSelect() {
      // 表格不存在，则直接返回
      if (!this.table) {
        return
      }
      // 多选
      if (this.multiple) {
        // 设置复选框状态
        this.updateSelectRow(this.selectedRows)
        return
      }
      // 单选
      this.updateCurrentRow(this.selectedRow)
    },

    /**
     * 更新当前选中的行
     * @param {Object} selectedRow 选中的行
     * @returns {void}
     */
    updateCurrentRow(selectedRow) {
      // 如果表格不存在，或者列表没有加载出来，则不需要更新
      if (!this.table || !this.list || !this.list.length) {
        return
      }
      // 如果选中数据是空，则直接将弹窗设置选中为空
      if (!selectedRow) {
        this.table.setCurrentRow()
        return
      }
      // 设置对应的信息项勾选
      this.list.some((item) => {
        if (item.userEmpsn === selectedRow) {
          this.table.setCurrentRow(item)
          return true
        }
        return false
      })
    },

    /**
     * 更新选中的行
     * @param {Array} selectedRows 勾选的行数
     * @returns {void}
     */
    updateSelectRow(selectedRows) {
      // 如果表格不存在，或者列表没有加载出来，则不需要更新
      if (!this.table || !this.list || !this.list.length) {
        return
      }
      // 如果勾选的数据不存在，则退出
      if (!selectedRows || !selectedRows.length) {
        this.clearTable()
        return
      }
      // 初始化开始
      this.initFlag = true
      // 当前选中的信息项，拷贝，因为下方可能会对它进行删除和信息项获取
      const sections = (this.table.store.states.selection || []).slice()
      // 选中id
      const selectedIds = sections.map((item) => item.userEmpsn)
      // 选中列表进行勾选
      this.list.forEach((item) => {
        // 是否选中
        const selected = selectedRows.indexOf(item.userEmpsn) > -1
        // 表格已经被选中
        const sectionExist = sections.indexOf(item) > -1
        // 之前选中索引
        const beforeIndex = selectedIds.indexOf(item.userEmpsn)
        // 如果表格本身已经选中，或者本身就没有被选中，则返回
        if (
          (selected && sectionExist) ||
          (!selected && !sectionExist && beforeIndex === -1)
        ) {
          return
        }
        // 是否选中
        let flag = false
        // 当前行需要选中，则进行选中
        if (selected) {
          // 如果已经选中，需要将之前的取消选中
          if (beforeIndex > -1) {
            // 再进行选中
            this.table.store.toggleRowSelection(
              sections[beforeIndex],
              false,
              false
            )
          }
          flag = true
        }
        // 再进行选中
        this.table.store.toggleRowSelection(item, flag, false)
      })
      this.table.store.updateAllSelected()
      // 初始化结束
      this.initFlag = false
      // 新选中的
      const newSelection = (this.table.store.states.selection || []).slice()
      this.handleSelectionChange(newSelection)
    }
  }
}
</script>

<style lang="scss">
// 组件样式
$class-prefix: "cosmo-select-user-table";
.#{$class-prefix} {
  position: relative;

  // 单选框，选中状态
  .el-radio__input.is-checked .el-radio__inner {
    background-color: #0055ff;
  }
  // 复选框，选中状态
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #0055ff;
    border-color: #0055ff;
  }
  // 表格样式
  &_table.el-table {
    margin-bottom: 16px;
    border: 1px solid #c9d7dd;
    width: 100%;

    &::before {
      display: none;
    }

    // 单元格、新增行
    th,
    td {
      padding: 0;
      height: 54px;
      font-size: 14px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 22px;
      // 单元格
      &.el-table__cell > .cell,
      > .cell {
        padding: 0 0 0 16px;
        white-space: nowrap;
      }
    }
    // 表头单元格
    th {
      font-weight: 600;
      // 单元格
      > .cell {
        border: none;
        margin: 0;
      }
      &.is-leaf {
        padding: 8px 0;
        border: none;
        border-bottom: 1px solid #dfe7ec;
        font-size: 14px;
        background-color: #f7f9fb;
        // 单元格
        > .cell {
          border: none;
          margin: 0;
        }
      }
      &.el-table__cell {
        // 单元格
        > .cell {
          padding: 0 0 0 16px;
        }
      }
    }
    // 滚动条影响标题栏空白，设置颜色
    .el-table__cell.gutter {
      background: #f7f9fb;
    }
    // 按钮
    .cell > .el-button {
      max-width: 100%;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  // 分页
  &_page {
    padding: 0 16px 16px;
    color: #606266;
    text-align: right;
    white-space: nowrap;
    .el-pager li {
      border-radius: 2px;
      background-color: #f4f4f5;
    }
    &.is-background .el-pager li:not(.disabled).active {
      background-color: #0055ff;
    }
  }
}
</style>
